const config = {
  breakpoints: {
    sm: 480,
    md: 800,
    lg: 1200,
  }
}

export default config;